import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BOIkon from "../../assets/images/bo-ikon-10.svg";

/* #region SCOPED CSS */
const StyledPage = styled.div`
    &.b-otag-is-now-hey-bo,
    &.b-otag-is-now-hey-bo * {
        box-sizing: border-box;
        font-family: "ItcAvantGardeGothicProDemi-Regular", sans-serif;
    }
    &.b-otag-is-now-hey-bo {
        background: #000000;
        width: 100vw;
        height: 100vh;
        width: 100dvw;
        height: 100dvh;
        position: relative;
        overflow: hidden;
        display: flex;
    }
    .frame-295922573 {
        display: flex;
        flex-direction: column;
        gap: 46px;
        align-items: center;
        justify-content: flex-start;
        width: 523px;

        //center with flex:
        margin: auto;
        justify-content: center;
        align-items: center;

        /*position: absolute;
        left: 698px;
        top: calc(50% - 135.65px);*/
    }
    .exclusion-7 {
        flex-shrink: 0;
        width: 102px;
        height: 90px;
        position: relative;
        overflow: visible;
    }
    .frame-295922572 {
        display: flex;
        flex-direction: column;
        gap: 56px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .b-otag-is-now-hey-bo2 {
        color: #ffffff;
        text-align: center;
        font-size: 48px;
        line-height: 24px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .b-otag-is-now-hey-bo-2-span {
        color: #ffffff;
        font-size: 48px;
        line-height: 24px;
        font-weight: 500;
        font-family: "ITC Avant Garde Gothic";
    }
    .b-otag-is-now-hey-bo-2-span2 {
        color: #ffffff;
        font-size: 48px;
        line-height: 24px;
        font-family: "ITC Avant Garde Gothic Pro Demi";
        font-style: normal;
        font-weight: 600;
    }
    .btn-lg-solid {
        background: #f7665f;
        border-radius: 9599.04px;
        padding: 0px 46px 0px 46px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 234px;
        height: 55.3px;
        position: relative;
        backdrop-filter: blur(12px);
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 9.6px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .go-to-hey-bo {
        color: #ffffff;
        text-align: center;
        font-size: 16px;
        line-height: 23.04px;
        font-weight: 600;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "ITC Avant Garde Gothic Pro Demi";
        font-weight: 600;
    }

    @media (max-width: 568px) {
        .frame-295922573,
        .frame-295922573 * {
            box-sizing: border-box;
        }
        .frame-295922573 {
            display: flex;
            flex-direction: column;
            gap: 32px;
            align-items: center;
            justify-content: flex-start;
            position: relative;
        }
        .exclusion-7 {
            flex-shrink: 0;
            width: 71px;
            height: 62px;
            position: relative;
            overflow: visible;
        }
        .frame-295922572 {
            display: flex;
            flex-direction: column;
            gap: 32px;
            align-items: center;
            justify-content: flex-start;
            align-self: stretch;
            flex-shrink: 0;
            position: relative;
        }
        .b-otag-is-now-hey-bo2 {
            color: #ffffff;
            text-align: center;
            font-size: 32px;
            line-height: 24px;
            font-weight: 400;
            position: relative;
            align-self: stretch;
        }
        .b-otag-is-now-hey-bo-2-span {
            color: #ffffff;
            font-size: 32px;
            line-height: 24px;
            font-weight: 500;
        }
        .b-otag-is-now-hey-bo-2-span2 {
            color: #ffffff;
            font-size: 32px;
            line-height: 24px;
            font-family: "ITC Avant Garde Gothic Pro Demi";
            font-style: normal;
            font-weight: 600;
        }
        .btn-lg-solid {
            background: #f7665f;
            border-radius: 9599.04px;
            padding: 0px 46px 0px 46px;
            display: flex;
            flex-direction: row;
            gap: 0px;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 234px;
            height: 55.3px;
            position: relative;
            backdrop-filter: blur(12px);
        }
        .frame-29590 {
            display: flex;
            flex-direction: row;
            gap: 9.6px;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            position: relative;
        }
        .go-to-hey-bo {
            color: #ffffff;
            text-align: center;
            font-size: 16px;
            line-height: 23.04px;
            font-weight: bold;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: "ITC Avant Garde Gothic Pro Demi";
            font-weight: 600;
        }
    }
`;
/* #endregion */

export default function BOTagRedirectPage() {
    /* #region VARS */
    const [routeInfoPathName, setRouteInfoPathName] = useState("");
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        const routeInfo = window.location.pathname;
        if (routeInfo) setRouteInfoPathName(routeInfo);
    }, []);
    /* #endregion */

    return (
        <StyledPage className="b-otag-is-now-hey-bo">
            <div className="frame-295922573">
                <img className="exclusion-7" src={BOIkon} alt="HeyBO logo" />
                <div className="frame-295922572">
                    <div className="b-otag-is-now-hey-bo2">
                        <span>
                            <span className="b-otag-is-now-hey-bo-2-span">BOtag is now</span>{" "}
                            <span className="b-otag-is-now-hey-bo-2-span2">HeyBO!</span>
                        </span>
                    </div>
                    <a href={`https://heybo.no${routeInfoPathName}`}>
                        <div className="btn-lg-solid">
                            <div className="frame-29590">
                                <div className="go-to-hey-bo">Go to HeyBO</div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </StyledPage>
    );
}
